/**
 * Сообщение, показываемое перед стартом ai-interview (gate-режим).
 */
export const INTERVIEW_GATE_MESSAGE = `Это тренировочное собеседование. У тебя будет **45 минут**, поставить интервью на паузу не получится. **Результат повлияет на рекомендательную систему**, поэтому важно проходить его честно.\n\nКогда будешь готов — жми «Начать», и я закреплю задание.`;
